// All major EDM and music festivals (89 total)
// Organized alphabetically for dropdown
export const allFestivals = [
  "ARC Music Festival",
  "Austin City Limits Music Festival",
  "Bass Canyon",
  "Bassrush",
  "Beyond Wonderland",
  "Beyond Wonderland at The Gorge",
  "Beyond Wonderland Chicago",
  "Big Dub Festival",
  "Boise Music Festival",
  "Bonnaroo Music Festival",
  "Breakaway Music Festival",
  "Coachella",
  "Countdown NYE",
  "CRSSD",
  "Cyclops Cove",
  "Dancefestopia",
  "Decadence",
  "Dreamstate",
  "Electric Daisy Carnival (EDC)",
  "Electric Daisy Carnival (EDC) Orlando",
  "Electric Forest",
  "Electric Zoo",
  "Elements Music & Arts Festival",
  "Escape Halloween",
  "Eternal NYE",
  "Firefly Music Festival",
  "Florida Groves Fest",
  "Forbidden Kingdom Music Festival",
  "Force Fields",
  "Freaky Deaky",
  "Gem and Jam",
  "Get Lucky Festival",
  "Global Dance Festival",
  "Governor's Ball Music Festival",
  "HARD Summer Music Festival",
  "High Roller",
  "HiJinx Music Festival",
  "Ill Points",
  "Indy 500 Snake Pitt",
  "Infrasound Music Festival",
  "Insomniac's Skyline Festival",
  "Jungle Bells",
  "Lightning In A Bottle",
  "Lollapalooza",
  "Lost Lands",
  "Lost In Dreams",
  "Lyrical Lemonade Summer Smash",
  "M3F Festival",
  "Movement",
  "North Coast Music Festival",
  "Nocturnal Wonderland",
  "Okeechobee Music & Arts Festival",
  "Palm Tree Music Festival",
  "Phoenix Lights Festival",
  "Pitchfork Music Festival",
  "Project Glow",
  "Red Rocks Events",
  "Relentless Beats Presents: Goldrush Music Festival",
  "Riot Fest",
  "Rolling Loud",
  "Sacred Acre Music Festival",
  "SHAQ's Bass All-Stars Festival",
  "Showcation",
  "Sound Haven",
  "Spring Awakening Music Festival (SAMF)",
  "Summer Camp Music Festival",
  "Summoning of the Eclipse Festival",
  "Sundown",
  "Sunset Music Festival",
  "System Overload Fest",
  "The Caverns Events",
  "Toxic Winter",
  "Tropical Dreams Festival",
  "Ubbi Dubbi",
  "Ultra Music Festival",
  "Valley of the Seven Stars Festival",
  "Wakaan Music Festival",
  "Wavefront Music Festival"
];

// Regional festival mappings for GPS-based suggestions
export const festivalsByRegion = {
  illinois: {
    name: "Illinois",
    coordinates: { lat: [41.5, 42.2], lon: [-88.3, -87.4] },
    festivals: [
      "Lollapalooza",
      "North Coast Music Festival",
      "Riot Fest",
      "Summer Camp Music Festival",
      "ARC Music Festival",
      "Beyond Wonderland Chicago",
      "Lyrical Lemonade Summer Smash"
    ]
  },
  kansas: {
    name: "Kansas",
    coordinates: { lat: [38.9, 39.3], lon: [-94.8, -94.4] },
    festivals: ["Dancefestopia"]
  },
  michigan: {
    name: "Michigan",
    coordinates: { lat: [43.2, 43.6], lon: [-86.5, -86.1] },
    festivals: ["Electric Forest", "Movement", "Breakaway Music Festival"]
  },
  ohio: {
    name: "Ohio",
    coordinates: { lat: [39.7, 40.3], lon: [-82.7, -82.1] },
    festivals: ["Lost Lands", "Breakaway Music Festival"]
  },
  tennessee: {
    name: "Tennessee",
    coordinates: { lat: [35.3, 36.4], lon: [-86.3, -85.8] },
    festivals: ["Bonnaroo Music Festival", "The Caverns Events", "Sound Haven"]
  },
  texasDallas: {
    name: "Texas (Dallas)",
    coordinates: { lat: [32.5, 33.0], lon: [-97.1, -96.6] },
    festivals: ["Ubbi Dubbi", "Breakaway Music Festival"]
  },
  texasHouston: {
    name: "Texas (Houston)",
    coordinates: { lat: [29.5, 30.0], lon: [-95.6, -95.1] },
    festivals: ["Breakaway Music Festival"]
  },
  texasAustin: {
    name: "Texas (Austin)",
    coordinates: { lat: [30.0, 30.6], lon: [-98.0, -97.5] },
    festivals: ["Austin City Limits Music Festival"]
  },
  wisconsin: {
    name: "Wisconsin",
    coordinates: { lat: [42.9, 43.4], lon: [-89.6, -89.1] },
    festivals: ["Force Fields"]
  },
  floridaMiami: {
    name: "Florida (Miami)",
    coordinates: { lat: [25.6, 26.0], lon: [-80.4, -80.0] },
    festivals: ["Ultra Music Festival", "Rolling Loud", "Ill Points"]
  },
  floridaOrlando: {
    name: "Florida (Orlando)",
    coordinates: { lat: [28.3, 28.7], lon: [-81.6, -81.1] },
    festivals: ["Electric Daisy Carnival (EDC) Orlando"]
  },
  floridaTampa: {
    name: "Florida (Tampa)",
    coordinates: { lat: [27.7, 28.2], lon: [-82.7, -82.2] },
    festivals: ["Forbidden Kingdom Music Festival", "Sunset Music Festival", "Breakaway Music Festival"]
  },
  floridaGeneral: {
    name: "Florida",
    coordinates: { lat: [25.0, 31.0], lon: [-87.6, -80.0] },
    festivals: ["Okeechobee Music & Arts Festival", "Florida Groves Fest", "Palm Tree Music Festival", "Cyclops Cove", "Eternal NYE"]
  },
  californiaLA: {
    name: "California (Los Angeles)",
    coordinates: { lat: [33.8, 34.3], lon: [-118.7, -117.9] },
    festivals: ["HARD Summer Music Festival", "Insomniac's Skyline Festival", "Cruel World"]
  },
  californiaSanBernardino: {
    name: "California (San Bernardino)",
    coordinates: { lat: [33.9, 34.3], lon: [-117.5, -117.0] },
    festivals: ["Beyond Wonderland", "Nocturnal Wonderland", "Escape Halloween"]
  },
  californiaIndio: {
    name: "California (Indio)",
    coordinates: { lat: [33.5, 33.9], lon: [-116.4, -116.0] },
    festivals: ["Coachella", "Stagecoach"]
  },
  californiaSanDiego: {
    name: "California (San Diego)",
    coordinates: { lat: [32.5, 33.0], lon: [-117.4, -116.9] },
    festivals: ["CRSSD"]
  },
  californiaCentralCoast: {
    name: "California (Central Coast)",
    coordinates: { lat: [35.2, 35.7], lon: [-120.9, -120.4] },
    festivals: ["Lightning In A Bottle"]
  },
  californiaSacramento: {
    name: "California (Sacramento)",
    coordinates: { lat: [38.4, 38.8], lon: [-121.7, -121.2] },
    festivals: ["Breakaway Music Festival"]
  },
  californiaSoCal: {
    name: "California (Southern California)",
    coordinates: { lat: [32.5, 34.5], lon: [-118.8, -116.0] },
    festivals: ["Dreamstate", "Bassrush", "Countdown NYE", "Toxic Winter", "Lost In Dreams"]
  },
  washingtonSeattle: {
    name: "Washington (Seattle)",
    coordinates: { lat: [47.4, 47.8], lon: [-122.6, -122.1] },
    festivals: ["Insomniac Boo!"]
  },
  washingtonGorge: {
    name: "Washington (The Gorge)",
    coordinates: { lat: [46.9, 47.3], lon: [-120.0, -119.6] },
    festivals: ["Bass Canyon", "Beyond Wonderland at The Gorge"]
  },
  washingtonDC: {
    name: "Washington D.C.",
    coordinates: { lat: [38.7, 39.1], lon: [-77.2, -76.8] },
    festivals: ["Project Glow"]
  },
  lasVegas: {
    name: "Las Vegas",
    coordinates: { lat: [35.9, 36.3], lon: [-115.4, -114.9] },
    festivals: ["Electric Daisy Carnival (EDC)", "High Roller"]
  },
  newYork: {
    name: "New York",
    coordinates: { lat: [40.5, 41.0], lon: [-74.3, -73.7] },
    festivals: ["Governor's Ball Music Festival", "Electric Zoo"]
  },
  arizona: {
    name: "Arizona (Phoenix)",
    coordinates: { lat: [33.2, 33.7], lon: [-112.3, -111.8] },
    festivals: ["Phoenix Lights Festival", "Decadence", "Gem and Jam", "M3F Festival", "Relentless Beats Presents: Goldrush Music Festival", "System Overload Fest", "Breakaway Music Festival"]
  },
  georgia: {
    name: "Georgia (Atlanta)",
    coordinates: { lat: [33.5, 34.0], lon: [-84.6, -84.2] },
    festivals: ["Breakaway Music Festival", "Jungle Bells"]
  },
  minnesota: {
    name: "Minnesota (St. Paul)",
    coordinates: { lat: [44.8, 45.2], lon: [-93.3, -92.8] },
    festivals: ["Breakaway Music Festival", "Infrasound Music Festival"]
  },
  massachusetts: {
    name: "Massachusetts",
    coordinates: { lat: [42.2, 42.5], lon: [-71.3, -70.8] },
    festivals: ["Breakaway Music Festival"]
  },
  pennsylvania: {
    name: "Pennsylvania (Philadelphia)",
    coordinates: { lat: [39.7, 40.2], lon: [-75.4, -74.9] },
    festivals: ["Breakaway Music Festival", "Big Dub Festival", "Elements Music & Arts Festival", "HiJinx Music Festival"]
  },
  northCarolina: {
    name: "North Carolina (Charlotte)",
    coordinates: { lat: [35.0, 35.4], lon: [-81.0, -80.6] },
    festivals: ["Breakaway Music Festival", "Carolina Open Air"]
  },
  utah: {
    name: "Utah",
    coordinates: { lat: [40.6, 40.9], lon: [-112.1, -111.7] },
    festivals: ["Breakaway Music Festival", "Get Lucky Festival"]
  },
  colorado: {
    name: "Colorado (Denver)",
    coordinates: { lat: [39.5, 39.9], lon: [-105.2, -104.7] },
    festivals: ["Red Rocks Events", "Global Dance Festival", "Decadence", "Palm Tree Music Festival"]
  },
  delaware: {
    name: "Delaware",
    coordinates: { lat: [38.9, 39.4], lon: [-75.7, -75.2] },
    festivals: ["Firefly Music Festival"]
  },
  connecticut: {
    name: "Connecticut",
    coordinates: { lat: [41.2, 42.0], lon: [-73.7, -71.8] },
    festivals: ["Tropical Dreams Festival"]
  },
  maryland: {
    name: "Maryland",
    coordinates: { lat: [38.0, 39.7], lon: [-79.5, -75.0] },
    festivals: ["Showcation"]
  },
  idaho: {
    name: "Idaho",
    coordinates: { lat: [43.4, 43.7], lon: [-116.3, -116.1] },
    festivals: ["Boise Music Festival"]
  },
  arkansas: {
    name: "Arkansas",
    coordinates: { lat: [34.7, 36.5], lon: [-94.6, -89.6] },
    festivals: ["Wakaan Music Festival"]
  },
  virginia: {
    name: "Virginia",
    coordinates: { lat: [36.5, 39.5], lon: [-83.7, -75.2] },
    festivals: ["Valley of the Seven Stars Festival"]
  },
  alabama: {
    name: "Alabama",
    coordinates: { lat: [30.2, 35.0], lon: [-88.5, -84.9] },
    festivals: ["Breakaway Music Festival"]
  },
  alaska: {
    name: "Alaska",
    coordinates: { lat: [61.2, 61.3], lon: [-149.9, -149.7] },
    festivals: ["Sacred Acre Music Festival", "Sundown"]
  },
  indiana: {
    name: "Indiana",
    coordinates: { lat: [39.7, 39.8], lon: [-86.3, -86.1] },
    festivals: ["Indy 500 Snake Pitt"]
  }
};

// Function to find which region a GPS coordinate belongs to
export const findRegionByCoordinates = (latitude, longitude) => {
  for (const [regionKey, region] of Object.entries(festivalsByRegion)) {
    const { coordinates } = region;
    
    if (
      latitude >= coordinates.lat[0] && 
      latitude <= coordinates.lat[1] &&
      longitude >= coordinates.lon[0] && 
      longitude <= coordinates.lon[1]
    ) {
      return regionKey;
    }
  }
  
  return null;
};

// Function to get festivals for a specific coordinate
export const getFestivalsForCoordinates = (latitude, longitude) => {
  const region = findRegionByCoordinates(latitude, longitude);
  
  if (region && festivalsByRegion[region]) {
    return festivalsByRegion[region].festivals;
  }
  
  return [];
};